/* ts-price-slider.js — dual-thumb price slider for the native price_range filter.
   Self-contained: no dependency on theme.js load order.
   Keeps the two range thumbs and the two number inputs in sync, paints the
   filled track, and submits the enclosing filter form so the existing AJAX
   listing handler picks the change up. */
(function () {
  'use strict';

  function initOne(root) {
    if (root.dataset.tsPriceReady === '1') return;
    root.dataset.tsPriceReady = '1';

    var max = parseInt(root.dataset.tsPriceMax, 10) || 0;
    var step = parseInt(root.dataset.tsPriceStep, 10) || 1;
    var sMin = root.querySelector('[data-ts-price-slider="min"]');
    var sMax = root.querySelector('[data-ts-price-slider="max"]');
    var nMin = root.querySelector('[data-ts-price-input="min"]');
    var nMax = root.querySelector('[data-ts-price-input="max"]');
    var fill = root.querySelector('[data-ts-price-fill]');
    if (!sMin || !sMax || !nMin || !nMax) return;

    function clamp(v) {
      v = parseInt(v, 10);
      if (isNaN(v)) return null;
      return Math.min(max, Math.max(0, v));
    }

    function paint() {
      if (!fill || !max) return;
      var lo = parseInt(sMin.value, 10) || 0;
      var hi = parseInt(sMax.value, 10);
      if (isNaN(hi)) hi = max;
      fill.style.insetInlineStart = (lo / max * 100) + '%';
      fill.style.width = ((hi - lo) / max * 100) + '%';
    }

    /* Keep the thumbs from crossing: each stays at least one step from the other. */
    function fromSlider(which) {
      var lo = parseInt(sMin.value, 10);
      var hi = parseInt(sMax.value, 10);
      if (which === 'min' && lo > hi - step) { lo = Math.max(0, hi - step); sMin.value = lo; }
      if (which === 'max' && hi < lo + step) { hi = Math.min(max, lo + step); sMax.value = hi; }
      nMin.value = lo > 0 ? lo : '';
      nMax.value = hi < max ? hi : '';
      paint();
    }

    function fromNumber() {
      var lo = clamp(nMin.value);
      var hi = clamp(nMax.value);
      if (lo === null) lo = 0;
      if (hi === null) hi = max;
      if (lo > hi) { var t = lo; lo = hi; hi = t; }
      sMin.value = lo;
      sMax.value = hi;
      paint();
    }

    /* Write the clamped/swapped values back into the boxes, so what the
       shopper reads always matches where the thumbs actually are. Only ever
       called on `change`, never on `input`, so it can't fight mid-typing. */
    function normalize() {
      var lo = parseInt(sMin.value, 10) || 0;
      var hi = parseInt(sMax.value, 10);
      if (isNaN(hi)) hi = max;
      nMin.value = lo > 0 ? lo : '';
      nMax.value = hi < max ? hi : '';
    }

    function submit() {
      normalize();
      var form = root.closest('form');
      if (!form) return;
      /* An empty bound must not serialize as "&filter.v.price.lte=" — the
         spec asks for shareable URLs, so drop unset bounds entirely. */
      var blanks = [nMin, nMax].filter(function (i) { return i.value === ''; });
      blanks.forEach(function (i) { i.disabled = true; });
      try {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      } finally {
        blanks.forEach(function (i) { i.disabled = false; });
      }
    }

    sMin.addEventListener('input', function () { fromSlider('min'); });
    sMax.addEventListener('input', function () { fromSlider('max'); });
    sMin.addEventListener('change', submit);
    sMax.addEventListener('change', submit);

    nMin.addEventListener('input', fromNumber);
    nMax.addEventListener('input', fromNumber);
    nMin.addEventListener('blur', normalize);
    nMax.addEventListener('blur', normalize);
    nMin.addEventListener('change', submit);
    nMax.addEventListener('change', submit);
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.type === 'number') { e.preventDefault(); submit(); }
    });

    paint();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ts-price]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Re-init after the Section Rendering API swaps the listing in. */
  window.TechStore = window.TechStore || {};
  window.TechStore.initPriceSlider = init;
})();
